export default __webpack_public_path__ + "static/media/calendar-new.cfe18c4f.svg";